<template>
    <div class="profile-loader">
        <div class="profile-card">
            <div class="shimmer-wrapper" style="width: 95%;height: 50px">
                <div class="navigator-wrapper">
                    <div style="width: 25px;height: 25px;margin-left: 10px;margin-top: 6px" class="shimmer-circle shimmer-circle-sm shimmer-animate"></div>
                    <div style="width: 50%;display: flex;flex-direction: column;margin-top: 3px;margin-left: 20%;">
                        <div class="shimmer-line shimmer-line-br shimmer-line-80 shimmer-animate mt-10"></div>
                    </div>
                </div>
            </div>
        </div>

    <div class="profile-body">
            <div style="width: 130px;height: 130px" class="shimmer-circle shimmer-circle-sm shimmer-animate"></div>
            <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-40 h-40"></div>
            <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-30 h-40"></div>
            <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-30 h-40"></div>
            <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-30 h-40"></div>
            <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-30 h-40"></div>
            <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between">
                <div class="shimmer-line shimmer-line-br shimmer-line-40 shimmer-animate mt-30 h-40"></div>
                <div class="shimmer-line shimmer-line-br shimmer-line-40 shimmer-animate mt-30 h-40"></div>
            </div>
            <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-30 h-40"></div>
            <div style="height: 80px" class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate mt-30"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProfileLoader'
}
</script>

<style>
.profile-loader{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #fff;
    padding: 0;
    z-index: 1000;
    overflow: hidden;
}

.profile-loader .profile-card{
    position: relative;
    width: 100%;
    padding: 5px;
    display: flex;
    flex-direction: column;
}

.profile-loader .profile-card .navigator-wrapper{
    position:  relative;
    width: 100%;
    height: 40px;
    border-radius: 10px;
    display: flex; 
    flex-direction: row;
    gap: 20px;
    background-color: #b9b9b9;
    margin-top: 5px;
    margin-left: 3px;
    padding-bottom: 0" class="mt-10
}

.profile-loader .profile-body{
    position:relative;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    padding: 10px
}
</style>